var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_c('div',{staticClass:"footer-tel"},[_vm._v("客服电话 | 400-0080-960")]),_c('div',{staticClass:"footer-copy"},[_c('p',[_vm._v("© 2016-2018 选址中国控股有限公司")]),_c('p',[_vm._v("京ICP备16020840号")])])])])
}]

export { render, staticRenderFns }